export default {
  files: state => state.files,
  file: state => state.file,
  thumbs: state => state.thumbs
}



// WEBPACK FOOTER //
// ./src/store/modules/files/getters.js